export const getSymbolOfChain = (_token: unknown): string => {
  return SOL_CHAIN_NAME
}

export const SOL_CHAIN_NAME = 'SOL'
